module.exports = __webpack_public_path__ + "img/fengdi-f1.1950294f.png";